import {
  StatsigProvider as BaseStatsigProvider,
  useClientAsyncInit,
} from '@statsig/react-bindings'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'
import { useEffect } from 'react'
import { StatsigClarityTracking } from './StatsigClarityTracking'
import { useShopify } from '@/hooks/useShopify'
import { useShouldEnableExperimentation } from '@/features/experimentation/hooks/useShouldEnableExperimentation'

const ExperimentationProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const shouldEnableExperimentation = useShouldEnableExperimentation()

  if (!shouldEnableExperimentation) {
    return <>{children}</>
  }

  return <StatsigProvider>{children}</StatsigProvider>
}

const StatsigProvider = ({ children }: { children: React.ReactNode }) => {
  const { environment } = useShopify()

  const statsigEnvironment: string = import.meta.env.DEV
    ? 'development'
    : environment && environment === 'production'
      ? 'production'
      : 'staging'

  const { client, isLoading } = useClientAsyncInit(
    'client-6zoxjENFI3muHcOlkcIJCDMvWNjrhpMAvgoQ8gNGs3A',
    {},
    {
      plugins: [new StatsigAutoCapturePlugin()],
      environment: {
        tier: statsigEnvironment,
      },
    },
  )

  useEffect(() => {
    if (!client) return

    const clarityTracking = new StatsigClarityTracking(client)

    clarityTracking.startTracking()

    return () => {
      clarityTracking.stopTracking()
    }
  }, [client])

  if (isLoading) {
    return <>{children}</>
  }

  return <BaseStatsigProvider client={client}>{children}</BaseStatsigProvider>
}

export default ExperimentationProvider
